<template>
  <div class="filter-container">
    <el-form :inline="true" label-width="90px">
      <el-row :gutter="20">
        <el-row :gutter="20">
          <el-form-item label="售后类型" class="form-item">
            <div class="tap-content">
              <div
                class="tap-item"
                v-for="item in afterSaleType.children"
                :key="item.id"
                @click="afterSaleTypeFn(item)"
                :class="{ 'tap-item-active': item.id === afterSaleActive }"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="状态" class="form-item">
            <div class="tap-content">
              <div
                class="tap-item"
                v-for="item in orderStatus.children"
                :key="item.id"
                @click="clickOrderStatus(item.id)"
                :class="{
                  'tap-item-active': orderStatusActive.includes(item.id),
                }"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="快速处理" class="form-item">
            <div class="tap-content">
              <div
                class="tap-item"
                v-for="item in fastTrackList"
                :key="item.id"
                @click="fastTrackActiveFn(item)"
                :class="{ 'tap-item-active': item.id === fastTrackActive }"
              >
                <span>{{ item.name }}</span>
              </div>
            </div>
            <!-- <el-radio-group v-model="searchInfo.fastTrack" v-removeAriaHidden>
              <el-radio>所有的</el-radio>
              <el-radio label="1">我发起的</el-radio>
              <el-radio label="2">待我处理的</el-radio>
            </el-radio-group> -->
          </el-form-item>
        </el-row>
      </el-row>

      <el-row :gutter="26">
        <el-col
          :span="22"
          class="key-input"
          style="border-right: 1px #e5e6eb solid"
        >
          <el-row style="display: flex; align-items: center">
            <el-col :span="16">
              <el-form-item class="key-input1">
                <el-input
                  clearable
                  size="mini"
                  v-model="searchInfo.keyword"
                  placeholder="支持输入售后单、设备编码、SN号、IMEI、Mac地址搜索"
                  @keyup.enter.native="filterData"
                  style="width: 100%"
                  suffix-icon="el-icon-search"
                >
                  <el-select
                    v-model="searchInfo.codeType"
                    slot="prepend"
                    placeholder="全部"
                    style="width: 5vw"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="售后单" value="1"></el-option>
                    <el-option label="设备编码" value="2"></el-option>
                    <el-option label="SN" value="3"></el-option>
                    <el-option label="IMEI" value="4"></el-option>
                    <el-option label="Mac地址" value="5"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请人">
                <el-input
                  clearable
                  v-model="searchInfo.creator"
                  placeholder="请输入"
                  size="mini"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户">
                <el-input
                  clearable
                  v-model="searchInfo.customerName"
                  placeholder="请输入"
                  size="mini"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备型号" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.deviceCodeId"
                  placeholder="全部"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in deviceNameList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                  <!-- <el-option label="全部" value="all"></el-option>
                  <el-option label="手机" value="phone"></el-option>
                  <el-option label="平板" value="tablet"></el-option> -->
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间">
                <el-date-picker
                  clearable
                  v-model="dateNow"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  size="mini"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row> </el-row>
        </el-col>
        <el-col :span="2" class="right-button">
          <el-button icon="el-icon-search" @click="search">查询</el-button>
          <el-button
            class="reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <div style="border-bottom: 1px #e5e6eb solid; margin-top: 20px"></div>
    <el-row>
      <el-button
        v-permission="'creat_after_sales'"
        icon="el-icon-plus"
        class="creat-btn"
        @click="creatOrder"
        >新建</el-button
      >
    </el-row>
    <el-row>
      <el-table
        v-loading="loading"
        empty-text="暂无数据"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="售后单号"
          width="150"
          prop="code"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              :style="{
                color: '#165DFF',
                cursor: 'pointer',
              }"
              @click="toDetail(scope.row)"
            >
              {{ scope.row.code || "--" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column align="center" label="售后类型"
          ><template slot-scope="scope">
            {{ tableCorType(scope.row.category) || "--" }}
          </template></el-table-column
        >
        <el-table-column align="center" label="状态" width="88">
          <template slot-scope="scope">
            <div class="status-content">
              <div
                class="status-color"
                v-if="scope.row.status"
                :style="getStatusColor(scope.row.status)"
              ></div>
              {{ tableStatusText(scope.row.status) || "--" }}
              <!-- {{ scope.row.status }} -->
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="客户" prop="customerName">
          <template slot-scope="scope">
            {{ scope.row.customerName || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="联系方式"
          prop="contact"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.contact || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="设备编码"
          prop="device.coding"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.device.coding || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="SN" prop="device.sn" width="155">
          <template slot-scope="scope">
            {{ scope.row.device.sn || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="IMEI"
          prop="device.imei"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.device.imei || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="MAC地址"
          prop="device.mac"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.device.mac || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备型号" prop="device.code">
          <template slot-scope="scope">
            {{ scope.row.device.code || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="激活日期"
          prop="device.firstBindTime"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.device.firstBindTime || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="保修期"
          prop="device.warranty"
          width="70"
        >
          <template slot-scope="scope">
            <div
              class="status-content"
              style="padding: 0 5px; box-sizing: border-box"
            >
              <div
                class="status-color"
                v-if="scope.row.device.warranty"
                :style="getWarrantyColor(scope.row.device.warranty)"
              ></div>
              {{ scope.row.device.warranty || "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="提交人"
          prop="creatorName"
          width="90"
        >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="auto">
              <div
                slot="reference"
                @click="toAccountDetail(scope.row)"
                class="submitted"
              >
                {{ scope.row.creatorName || "--" }}
              </div>

              <div
                style="
                  display: flex;
                  text-overflow: ellipsis;
                  white-space: pre-line;
                  cursor: pointer;
                  color: #165dff;
                "
              >
                <span @click="toAccountDetail(scope.row)">
                  {{ scope.row.creatorName || "--" }}
                </span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
          prop="createdAt"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.createdAt || "--" }}
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          @current-change="changepagefn"
          :page-size="size"
          :current-page="page"
          layout="->,total,prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getDictMap } from "../../utils/util";
export default {
  data() {
    return {
      searchInfo: {
        category: "",
        status: "",
        fastTrack: "",
        keyword: "",
        creator: "",
        customerName: "",
        deviceCodeId: "",
        createdAt: "",
        codeType: "",
      },
      dateNow: "",
      size: 10,
      total: 0,
      page: 1,
      loading: false,
      tableData: [],
      afterSaleType: [],
      orderStatus: [],
      tableType: [],
      afterSaleActive: "1",
      orderStatusActive: ["1"],
      fastTrackActive: "0",
      fastTrackList: [
        {
          name: "所有的",
          id: "0",
        },
        {
          name: "我发起的",
          id: "1",
        },
        {
          name: "待我处理的",
          id: "2",
        },
      ],
      dictMap: {},
    };
  },
  created() {
    this.dictMap = getDictMap();
    // 获取设备型号的选项列表
    this.deviceNameList = JSON.parse(localStorage.getItem("deviceName"));
  },
  mounted() {
    this.getDict();
    this.getDataList();
  },
  watch: {
    orderStatusActive(newval) {
      if (newval.length === 0) {
        this.orderStatusActive = ["1"];
        return;
      }
    },
  },
  computed: {},
  methods: {
    toAccountDetail(row) {
      console.log("toAccountDetail", row);
      // const params = JSON.stringify(row);
      if (this.$jumpPerm("account_detail")) {
        this.$router.push({
          path: "/userInfo",
          query: { params: row.creator, fromAccountList: true },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    afterSaleTypeFn(item) {
      this.afterSaleActive = item.id;
      this.search();
    },
    fastTrackActiveFn(item) {
      this.fastTrackActive = item.id;
      this.search();
    },
    getWarrantyColor(val) {
      switch (val) {
        case "在保":
          return { backgroundColor: "#165DFF" };
        case "过保":
          return { backgroundColor: "#F53F3F" };
        default:
          return {}; // 返回一个空对象，而不是 `undefined` 或空字符串
      }
    },
    getStatusColor(val) {
      const value = this.tableStatus(val);

      switch (value) {
        case "pre_inspection_of_receiving_goods":
          return { backgroundColor: "#ff7d00" };
        case "under_repair":
          return { backgroundColor: "#165DFF" };
        case "pending_review":
        case "to_be_returned":
        case "to_be_sent_out":
          return { backgroundColor: "#F53F3F" };
        case "returned_inventory":
        case "sent_out":
        case "returned":
          return { backgroundColor: "#00B42A" };
        case "cancelled":
          return { backgroundColor: "#C9CDD4" };
        default:
          return {};
      }
    },
    clickOrderStatus(code) {
      console.log("clickOrderStatus==", code);
      if (this.orderStatusActive.includes(code)) {
        console.log("code==", code);

        if (code === "1") {
          this.orderStatusActive = ["1"];
          return;
        }
        if (this.orderStatusActive.length === 10) {
          this.orderStatusActive = this.orderStatusActive.filter(
            (i) => i !== "1"
          );
        }
        this.orderStatusActive = this.orderStatusActive.filter(
          (i) => i !== code
        );

        // console.log("this.orderStatusActive", this.orderStatusActive);
      } else {
        // console.log("this.orderStatusActive2", this.orderStatusActive);
        if (code === "1") {
          this.orderStatusActive = ["1"];
          this.search();
          return;
        } else if (this.orderStatusActive.length === 8) {
          this.orderStatusActive.push("1");
        } else {
          this.orderStatusActive = this.orderStatusActive.filter(
            (i) => i !== "1"
          );
        }
        this.orderStatusActive.push(code);
      }
      this.search();
    },
    toDetail(val) {
      console.log(val);
      if (this.$jumpPerm("after_sales_order")) {
        this.$router.push({
          path: "/afterSaleOrder",
          query: {
            id: val.id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    handleDateChange(dates) {
      if (dates && dates.length) {
        let createdAt = `${dates[0]} 00:00:00` + "~" + `${dates[1]} 23:59:59`;
        this.searchInfo.createdAt = createdAt;
      }
    },
    creatOrder() {
      this.$router.push({
        path: "/afterSaleOrder",
        query: {
          isCreat: true,
        },
      });
    },
    getDataList(info) {
      this.$get("/aftersales/order/list", {
        page: this.page,
        size: 10,
        ...info,
      }).then((res) => {
        if (res.data.data && res.data.data.list) {
          const data = res.data.data;
          this.tableData = data.list;
          this.total = data.count;
        }
      });
    },
    getDict() {
      const afterSaleType = this.dictMap["after_sales_type"];
      this.afterSaleType = afterSaleType;
      this.afterSaleType.children.unshift({
        name: "所有的",
        id: "1",
      });
      const orderStatus = this.dictMap["process_status"];
      this.orderStatus = {
        ...orderStatus,
        children: orderStatus.children.filter((i) => i.name !== "提交售后单"),
      };
      this.orderStatus.children.unshift({
        name: "所有的",
        id: "1",
      });
      const tableType = this.dictMap["after_sales_type"];
      this.tableType = tableType.children;
    },

    tableCorType(id) {
      const item = this.tableType.find((i) => id === i.id);
      return item ? item.name : null;
    },
    tableStatus(id) {
      const item = this.orderStatus.children.find((i) => id === i.id);
      return item ? item.code : null;
    },
    tableStatusText(id) {
      const code = this.tableStatus(id);
      return this.dictMap[code]?.name;
    },
    search() {
      // 执行搜索操作
      console.log("搜索内容：", this.searchInfo);

      const codeTypeMapping = {
        1: "code",
        2: "coding",
        3: "sn",
        4: "imei",
        5: "mac",
      };

      // 清空相关属性
      Object.keys(codeTypeMapping).forEach((key) => {
        this.searchInfo[codeTypeMapping[key]] = "";
      });

      // 赋值和清空关键字
      if (this.searchInfo.codeType !== 0) {
        const field = codeTypeMapping[this.searchInfo.codeType];
        if (field) {
          this.searchInfo[field] = this.searchInfo.keyword;
          // this.searchInfo.keyword = "";
        }
      }
      if (this.afterSaleActive === "1") {
        this.searchInfo.category = "";
      } else {
        this.searchInfo.category = this.afterSaleActive;
      }
      if (this.fastTrackActive === "0") {
        this.searchInfo.fastTrack = "";
      } else {
        this.searchInfo.fastTrack = this.fastTrackActive;
      }
      if (this.orderStatusActive.includes("1")) {
        this.searchInfo.status = "";
      } else {
        this.searchInfo.status = this.orderStatusActive.join(",");
      }
      this.page = 1;
      this.getDataList(this.searchInfo);
    },
    reset() {
      this.dateNow = "";
      this.afterSaleActive = "1";
      this.orderStatusActive = ["1"];
      this.fastTrackActive = "0";
      this.searchInfo = {
        category: "",
        status: "",
        fastTrack: "",
        keyword: "",
        creator: "",
        customerName: "",
        deviceCodeId: "",
        createdAt: "",
        codeType: "",
      };
      this.getDataList();
    },
    changepagefn(index) {
      this.page = index;
      this.getDataList(this.searchInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.filter-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
}
.key-input {
  /* margin-right: 10px; */
  // padding-right: 0px !important;
}
::v-deep .key-input .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .key-input1 {
  width: 100%;
}

::v-deep .key-input .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item {
  display: flex !important;
}
.right-button {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  .el-button {
    width: 82px;
    height: 28px;
    background-color: #165dff;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: 5px;
  }
  .reset-btn {
    color: #4e5969;
    background-color: #f2f3f5;
    margin-left: 0 !important;
    margin-top: 13px;
  }
}
.creat-btn {
  margin: 20px 0;
  width: 82px;
  height: 28px;
  background-color: #165dff;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.creat-btn:hover {
  background-color: #165dff;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.form-item {
  display: flex;
  align-items: center;
}
.tap-content {
  display: flex;
  align-items: center;
  .tap-item {
    padding: 3px 16px;
    background-color: #f2f3f5;
    border-radius: 16px;
    box-sizing: border-box;
    margin-right: 8px;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    cursor: pointer;
  }
  .tap-item-active {
    background-color: #165dff;
    color: #fff;
  }
}
::v-deep .el-form-item__label {
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
}
.status-content {
  display: flex;
  width: 100%;
  align-items: center;
  // justify-content: space-between;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
.submitted {
  color: #165dff;
  cursor: pointer;
  width: 90px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
.el-popover {
  width: auto !important;
}
</style>
